import React, { useState } from 'react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [open, setOpen] = useState<ModalType>(null);
  const close = () => setOpen(null);
  return <>
      {/* Footer */}
      <footer className="w-full py-8 px-6 border-t" style={{
      backgroundColor: '#111111',
      borderColor: '#2A2A2A'
    }} data-id="element-1">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left" data-id="element-2">
          <p style={{
          color: '#6B7280',
          fontFamily: 'Inter, sans-serif'
        }} className="text-sm" data-id="element-3">
            © 2025 Airbnb Superhost Spanish OS · Todos los derechos reservados
          </p>
          <div className="flex items-center gap-6" data-id="element-4">
            <button onClick={() => setOpen('privacy')} className="text-sm transition-colors duration-150 hover:underline" style={{
            color: '#9CA3AF',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-5">
              Política de Privacidad
            </button>
            <span style={{
            color: '#2A2A2A'
          }} data-id="element-6">
              |
            </span>
            <button onClick={() => setOpen('terms')} className="text-sm transition-colors duration-150 hover:underline" style={{
            color: '#9CA3AF',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-7">
              Términos y Condiciones
            </button>
          </div>
        </div>
        <div className="max-w-4xl mx-auto mt-4 text-center" data-id="element-8">
          <p style={{
          color: '#4B5563',
          fontFamily: 'Inter, sans-serif'
        }} className="text-xs" data-id="element-9">
            Este producto es un sistema digital educativo. No está afiliado con
            Airbnb Inc.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      {open !== null && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{
      backgroundColor: 'rgba(0,0,0,0.7)'
    }} onClick={close} data-id="element-10">
          <div className="relative w-full max-w-2xl max-h-[80vh] overflow-y-auto rounded-2xl p-8 shadow-2xl" style={{
        backgroundColor: '#FAFAF8'
      }} onClick={e => e.stopPropagation()} data-id="element-11">
            {/* Close button */}
            <button onClick={close} className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full text-lg font-bold transition-colors duration-150" style={{
          color: '#6B7280',
          backgroundColor: '#F5F0EB'
        }} aria-label="Cerrar" data-id="element-12">
              ×
            </button>

            {open === 'privacy' && <PrivacyContent data-id="element-13" />}
            {open === 'terms' && <TermsContent data-id="element-14" />}
          </div>
        </div>}
    </>;
}
function PrivacyContent() {
  return <div data-id="element-15">
      <h2 className="text-2xl font-extrabold mb-6" style={{
      color: '#1A1A1A',
      fontFamily: 'Plus Jakarta Sans, sans-serif'
    }} data-id="element-16">
        Política de Privacidad
      </h2>
      <div className="space-y-4 text-sm leading-relaxed" style={{
      color: '#6B7280',
      fontFamily: 'Inter, sans-serif'
    }} data-id="element-17">
        <p style={{
        color: '#1A1A1A'
      }} className="font-semibold" data-id="element-18">
          Última actualización: 2025
        </p>

        <Section title="1. Información que recopilamos" data-id="element-19">
          Al realizar una compra, recopilamos únicamente la información
          necesaria para procesar tu pedido: nombre y dirección de correo
          electrónico. Esta información es procesada de forma segura a través de
          nuestra plataforma de pago.
        </Section>

        <Section title="2. Uso de la información" data-id="element-20">
          Utilizamos tu información exclusivamente para: (a) entregar el
          producto digital adquirido, (b) enviarte actualizaciones del producto
          si las hubiera, y (c) responder a consultas de soporte. No vendemos,
          alquilamos ni compartimos tu información personal con terceros.
        </Section>

        <Section title="3. Almacenamiento y seguridad" data-id="element-21">
          Tu información se almacena de forma segura. Utilizamos medidas
          técnicas y organizativas estándar de la industria para proteger tus
          datos contra acceso no autorizado, pérdida o divulgación.
        </Section>

        <Section title="4. Cookies" data-id="element-22">
          Este sitio puede utilizar cookies técnicas necesarias para su
          funcionamiento. No utilizamos cookies de seguimiento publicitario de
          terceros.
        </Section>

        <Section title="5. Tus derechos" data-id="element-23">
          Tienes derecho a acceder, corregir o solicitar la eliminación de tu
          información personal en cualquier momento. Para ejercer estos
          derechos, puedes comunicarte con nosotros a través de la plataforma
          donde adquiriste el producto.
        </Section>

        <Section title="6. Cambios a esta política" data-id="element-24">
          Nos reservamos el derecho de actualizar esta política en cualquier
          momento. Los cambios serán publicados en esta página con la fecha de
          actualización correspondiente.
        </Section>
      </div>
    </div>;
}
function TermsContent() {
  return <div data-id="element-25">
      <h2 className="text-2xl font-extrabold mb-6" style={{
      color: '#1A1A1A',
      fontFamily: 'Plus Jakarta Sans, sans-serif'
    }} data-id="element-26">
        Términos y Condiciones
      </h2>
      <div className="space-y-4 text-sm leading-relaxed" style={{
      color: '#6B7280',
      fontFamily: 'Inter, sans-serif'
    }} data-id="element-27">
        <p style={{
        color: '#1A1A1A'
      }} className="font-semibold" data-id="element-28">
          Última actualización: 2025
        </p>

        <Section title="1. Aceptación de los términos" data-id="element-29">
          Al adquirir el producto "Airbnb Superhost Spanish OS", aceptas estos
          Términos y Condiciones en su totalidad. Si no estás de acuerdo con
          alguno de estos términos, no debes realizar la compra.
        </Section>

        <Section title="2. Descripción del producto" data-id="element-30">
          "Airbnb Superhost Spanish OS" es un sistema digital educativo que
          incluye plantillas, guías y protocolos de comunicación para
          anfitriones de rentas cortas. Es un producto de descarga digital, no
          un servicio de suscripción.
        </Section>

        <Section title="3. Licencia de uso" data-id="element-31">
          Al adquirir este producto, obtienes una licencia personal, no
          exclusiva e intransferible para usar el contenido. Queda estrictamente
          prohibida la reventa, redistribución o reproducción del material sin
          autorización expresa por escrito.
        </Section>

        <Section title="4. Política de reembolso" data-id="element-32">
          Dado que se trata de un producto digital de descarga inmediata, no se
          ofrecen reembolsos una vez que el acceso ha sido entregado. Te
          recomendamos revisar cuidadosamente la descripción del producto antes
          de realizar tu compra.
        </Section>

        <Section title="5. Limitación de responsabilidad" data-id="element-33">
          Este producto es de carácter educativo e informativo. Los resultados
          pueden variar según el anfitrión, la propiedad y la plataforma
          utilizada. No garantizamos resultados específicos. El usuario es
          responsable de la implementación y uso del sistema.
        </Section>

        <Section title="6. Propiedad intelectual" data-id="element-34">
          Todo el contenido de este producto, incluyendo textos, plantillas y
          guías, es propiedad intelectual del creador. Queda prohibida su
          reproducción total o parcial sin autorización.
        </Section>

        <Section title="7. Modificaciones" data-id="element-35">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones entrarán en vigor desde su publicación.
        </Section>
      </div>
    </div>;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div data-id="element-36">
      <h3 className="font-semibold mb-1" style={{
      color: '#1A1A1A',
      fontFamily: 'Plus Jakarta Sans, sans-serif'
    }} data-id="element-37">
        {title}
      </h3>
      <p data-id="element-38">{children}</p>
    </div>;
}